import React from "react";
import { useFeatureFlag } from "../../../../launch-darkly/useLaunchDarkly";
import { LottiePlayer } from "../../../lottie-player/LottiePlayer";
import { Header, SlideLayout, Text } from "../../shared-components";
import LunchAnimation from "./assets/lunch-full.lottie";
import lunchImage from "./assets/lunch.svg";

const Image = () => {
  return <img src={lunchImage} className="cw-w-full md:cw-h-[475px] cw-mt-3" />;
};

export const LunchSlide = () => {
  const [isOnAIOnboarding] = useFeatureFlag("rollout-ai-onboarding");
  if (isOnAIOnboarding) {
    return (
      <SlideLayout>
        <Header>And never miss lunch again</Header>
        <Text>
          Clockwise can dynamically block time for lunch, adjusting its time and duration as new
          events appear.
        </Text>
        <Image />
      </SlideLayout>
    );
  }
  return (
    <SlideLayout>
      <Header> Protect your lunch break </Header>
      <Text>
        Clockwise protects your lunch break on even the most packed days. You can always edit these
        settings later.
      </Text>
      <div className="cw-px-4 ">
        <LottiePlayer autoplay loop={1} src={LunchAnimation} className="lg:cw-h-[400px]" />
      </div>
    </SlideLayout>
  );
};
